<template>
  <div class="admin-home">
    <section class="hero is-light">
      <div class="hero-body">
        <div class="container">
          <div class="level">
            <div class="level-left">
              <h1 class="title level-item">Admin</h1>
            </div>
            <div class="level-right">
              <div class="level-item">
                <a class="button is-danger" :class="{ 'is-loading': saving}" @click="saveButtonPressed">Save</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="section">
      <div class="container">
        <h2 class="title is-3">About us</h2>
        <vue-ckeditor v-model="about" :config="config" />
      </div>
    </section>
    <hr>
    <section class="section">
      <div class="container">
        <h2 class="title is-3">Services</h2>
        <div class="columns is-multiline">
          <div class="column is-one-third" v-for="(service, index) in services" :key="index">
            <form class="box">
              <div class="field">
                <label class="label">Title</label>
                <div class="control">
                  <input class="input is-small" type="text" placeholder="Title" v-model="service.title">
                </div>
              </div>
              <div class="field">
                <label class="label">Description</label>
                <div class="control">
                  <textarea class="textarea is-small" type="text" placeholder="Description" v-model="service.description"></textarea>
                </div>
              </div>
              <img :src="service.imageUrl">
              <div class="field">
                <div class="file is-small">
                  <label class="file-label">
                    <input class="file-input" type="file" name="resume" @change="uploadServiceIcon($event, index)">
                    <span class="file-cta">
                      <span class="file-icon">
                        <i class="fas fa-upload"></i>
                      </span>
                      <span class="file-label">Upload icon</span>
                    </span>
                  </label>
                </div>
                <p class="help">72 x 72</p>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
    <hr>
    <section class="section">
      <div class="container">
        <h2 class="title is-3">Brands</h2>
        <div class="columns is-multiline">
          <div class="brand column is-one-quarter" v-for="(brand, index) in brands" :key="index">
            <div class="box">
              <button class="admin__delete delete" @click.prevent="deleteBrand(index)"></button>
              <h3 class="title is-size-4">{{ brand.title }}</h3>
              <router-link :to="{ name: 'admin-brand', params: { brandSlug: brand.slug, brands: brands, index: index }}">Edit</router-link>
              <img :src="brand.productImageUrl">
            </div>
          </div>
          <div class="column is-one-quarter">
            <div class="box">
              <div class="field has-addons">
                <div class="control">
                  <input class="input" type="text" placeholder="Title" v-model="newBrandTitle">
                </div>
                <div class="control">
                  <a class="button is-danger" @click.prevent="addBrand">Add brand</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <hr>
    <section class="section">
      <div class="container">
        <h2 class="title is-3">Partners carousel</h2>
        <div class="columns is-multiline">
          <div class="partner column is-one-quarter" v-for="(partner, index) in partners" :key="index">
            <div class="box">
              <button class="admin__delete delete" @click.prevent="deletePartner(index)"></button>
              <form @submit.prevent="addNewPartner(e)">
                <div class="field">
                  <label class="label">URL</label>
                  <div class="control">
                    <input class="input" type="url" placeholder="https://..." v-model="partners[index].url">
                  </div>
                </div>
                <div class="partner__loader loader"></div>
                <img :src="partners[index].imageUrl">
                <div class="field">
                  <div class="file has-name is-boxed">
                    <label class="file-label">
                      <input class="file-input" type="file" name="resume" @change="processFile(index, $event)">
                      <span class="file-cta">
                        <span class="file-icon">
                          <i class="fas fa-upload"></i>
                        </span>
                        <span class="file-label">Choose a file…</span>
                      </span>
                      <span class="file-name">{{ partners[index].imageUrl }}</span>
                    </label>
                  </div>
                  <div class="help">~ 300px wide</div>
                </div>
              </form>
            </div>
          </div>
          <div class="column is-one-quarter">
            <div class="box">
              <button class="button is-danger" @click="addNewPartner">Add new slide</button>
            </div>
          </div>
        </div>
      </div>
    </section>
    <hr>
    <section class="section">
      <div class="container">
        <h2 class="title">Contact form</h2>
        <div class="box contact-form-box">
          <h3 class="title is-4">Send to</h3>
          <ul class="contact-form-email-list">
            <li class="contact-form-email-list-item" v-for="(email, index) in contactFormEmails" :key="index">
              <span class="contact-form-email-list__email">{{ email }}</span>
              <button class="delete contact-form-email-list__delete" @click.prevent="deleteEmail(index)"></button>
            </li>
          </ul>
          <form @submit.prevent="addNewEmail($event)">
            <label class="label is-small hide" for="email">Title</label>
            <div class="field has-addons">

              <div class="control">
                <input class="input is-small" type="email" placeholder="Email" id="contactEmail" v-model="newContactFormEmail">
              </div>
              <p class="control">
                <button class="button is-danger is-small">Add</button>
              </p>
            </div>
          </form>
        </div>
      </div>
    </section>
    <hr>
    <section class="section">
      <div class="container">
        <h2 class="title is-3">Footer links</h2>
        <div class="columns">
          <div class="column is-one-quarter">
            <div class="box">
              <h3 class="title is-4">Our shops</h3>
              <ul class="our-shops-list">
                <li class="our-shops-list__item" v-for="(shop, i) in shops" :key="i">
                  <a :href="shop.url">{{ shop.title }}</a>
                  <button class="delete" @click="removeShop(i)"></button>
                </li>
              </ul>
              <form @submit.prevent="addNewShop($event)">
                <div class="field">
                  <label class="label is-small hide" for="shopTitle">Title</label>
                  <div class="control">
                    <input class="input is-small" type="text" placeholder="Title" id="shopTitle" v-model="newShop.title">
                  </div>
                </div>
                <div class="field">
                  <label class="label is-small hide" for="shopUrl">URL</label>
                  <div class="control">
                    <input class="input is-small" type="url" placeholder="https://..." id="shopUrl" v-model="newShop.url">
                  </div>
                </div>
                <div class="field">
                  <p class="control">
                    <button class="button is-danger is-small">Add</button>
                  </p>
                </div>
              </form>
            </div>
          </div>
          <div class="column is-one-quarter">
            <div class="box">
              <h3 class="title is-4">Social Links</h3>
              <form>
                <div class="field">
                  <label class="label is-small">Facebook</label>
                  <div class="control">
                    <input class="input is-small" type="url" placeholder="https://..." v-model="socialLinks.facebook">
                  </div>
                </div>
                <div class="field">
                  <label class="label is-small">Twitter</label>
                  <div class="control">
                    <input class="input is-small" type="url" placeholder="https://..." v-model="socialLinks.twitter">
                  </div>
                </div>
                <div class="field">
                  <label class="label is-small">Instagram</label>
                  <div class="control">
                    <input class="input is-small" type="url" placeholder="https://..." v-model="socialLinks.instagram">
                  </div>
                </div>
                <div class="field">
                  <label class="label is-small">Youtube</label>
                  <div class="control">
                    <input class="input is-small" type="url" placeholder="https://..." v-model="socialLinks.youtube">
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div class="column is-one-quarter">
            <div class="box">
              <h3 class="title is-4">Contact Details</h3>
              <form>
                <div class="field">
                  <label class="label is-small">Phone</label>
                  <div class="control">
                    <input class="input is-small" type="tel" placeholder="Phone" v-model="contactDetails.phone">
                  </div>
                </div>
                <div class="field">
                  <label class="label is-small">Email</label>
                  <div class="control">
                    <input class="input is-small" type="email" placeholder="Email" v-model="contactDetails.email">
                  </div>
                </div>
                <div class="field">
                  <label class="label is-small">Working hours</label>
                  <div class="control">
                    <input class="input is-small" type="text" placeholder="Working hours" v-model="contactDetails.workingHours">
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import {db, storage} from '@/firebase.js'
import VueCkeditor from 'vue-ckeditor2'
import slugify from 'slugify'

export default {
  components: { VueCkeditor },
  data() {
    return {
      about: null,
      brands: [],
      newBrandTitle: null,
      newBrand: {
        title: null,
        slug: null,
        url: null,
        colour: null,
        descriptionOne: null,
        descriptionTwo: null,
        descriptionThree: null,
        logoUrl: null,
        logoWhiteUrl: null,
        productImageUrl: null,
        bannerImageUrl: null,
        ingredients: []
      },
      services: [],
      partners: [],
      contactFormEmails: [],
      newContactFormEmail: null,
      shops: [],
      newShop: {
        title: null,
        url: null
      },
      socialLinks: {
        facebook: null,
        twitter: null,
        instagram: null,
        youtube: null
      },
      contactDetails: {
        phone: null,
        email: null,
        workingHours: null
      },
      config: {
        toolbar: [
          ['Bold', 'Italic', 'Underline', 'Link']
        ],
        height: 200
      },
      saving: false
    }
  },
  methods: {
    saveButtonPressed(e) {
      this.saving = true
      db.collection('app').doc('appData').update({
        about: this.about,
        services: this.services,
        brands: this.brands,
        partners: this.partners,
        contactFormEmails: this.contactFormEmails,
        shops: this.shops,
        socialLinks: this.socialLinks,
        contactDetails: this.contactDetails
      })
      .then(() => {
        alert('Save successful')
      })
      .catch(() => {
        alert('Save failed')
      })
      .finally(() => {
        this.saving = false
      })
    },
    uploadServiceIcon(e, index) {
      var file = e.target.files[0]
      const nameFormat = file.name.split('.')
      const name = nameFormat[0] + '-' + Date.now() + '.' + nameFormat[1]
      const metadata = { contentType: file.type }      

      storage.ref().child(`services/${name}`).put(file, metadata)
      .then(snapshot => snapshot.ref.getDownloadURL())
      .then(url => {
        this.services[index].imageUrl = url
        // loader.classList.remove('shown')
      })
      .catch(() => {
        // loader.classList.remove('shown')
      })
    },
    addBrand() {
      const title = this.newBrandTitle
      const slug = slugify(title, {
        replacement: '-',
        remove: /[$*_+~.()'"!\-:@;/?=&<>\\#%{}|^[\]`]/g,
        lower: true
      })

      const data = {
        title: title,
        slug: slug,
        colour: null,
        url: null,
        descriptionOne: null,
        descriptionTwo: null,
        descriptionThree: null,
        logoUrl: null,
        logoUrlWhiteUrl: null,
        productImageUrl: null,
        bannerImageUrl: null,
        ingredients: []
      }
      
      this.brands.push(data)

      this.newBrandTitle = null
    },
    deleteBrand(index) {
      if (confirm("Are you sure? This will permanently delete this brand.")) {
        const deletedBrand = this.brands[index]
        this.brands.splice(index, 1);
        db.collection('app').doc('appData').update({
          brands: this.brands
        }).catch(() => {
          this.brands.splice(index, 0, deletedBrand)
        })
      }
    },
    processFile(i, e) {
      const loader = document.getElementsByClassName('partner')[i].getElementsByClassName('loader')[0]

      loader.classList.add('shown')

      var file = e.target.files[0]
      const nameFormat = file.name.split('.')
      const name = nameFormat[0] + '-' + Date.now() + '.' + nameFormat[1]
      const metadata = { contentType: file.type }      

      storage.ref().child(`partners/${name}`).put(file, metadata)
      .then(snapshot => snapshot.ref.getDownloadURL())
      .then(url => {
        this.partners[i].imageUrl = url
        loader.classList.remove('shown')
      })
      .catch(() => {
        loader.classList.remove('shown')
      })
    },
    addNewPartner(e) {
      const data = {
        url: null,
        imageUrl: null
      }
      this.partners.push(data)
    },
    deletePartner(index) {
      if (confirm("Are you sure? This will permanently delete this slide.")) {
        const deletedPartner = this.partners[index]
        this.partners.splice(index, 1);
        db.collection('app').doc('appData').update({
          partners: this.partners
        }).catch(() => {
          this.partners.splice(index, 0, deletedPartner)
        })
      }
    },
    addNewEmail(e) {
      const form = e.target
      this.contactFormEmails.push(this.newContactFormEmail)
      this.newContactFormEmail = null
    },
    deleteEmail(index) {
      this.contactFormEmails.splice(index, 1)
    },
    addNewShop(e) {
      const form = e.target
      const data = {
        title: this.newShop.title,
        url: this.newShop.url
      }
      this.shops.push(data)
      form.reset()
    },
    removeShop(i) {
      this.shops.splice(i, 1)
    }
  },
  created() {
    db.collection('app').doc('appData').get()
    .then(doc => {
      const data = doc.data()
      this.about = data.about? data.about : null
      this.services = data.services? data.services : []
      this.brands = data.brands? data.brands : []
      this.partners = data.partners? data.partners : []
      this.contactFormEmails = data.contactFormEmails? data.contactFormEmails : []
      this.shops = data.shops? data.shops : []
      this.socialLinks = data.socialLinks? data.socialLinks : {}
      this.contactDetails = data.contactDetails? data.contactDetails : {}
    })
  }
}
</script>

<style lang="scss" scoped>
.hero {
  margin-bottom: 0;
}

.our-shops-list {
  margin-bottom: 20px;
}
.our-shops-list__item {
  display: flex;
  justify-content: space-between;
}
.brand .box,
.partner .box {
  position: relative;
}
.admin__delete {
  position: absolute;
  top: 10px;
  right: 10px;
}
.partner__loader {
  display: none;
  &.shown {
    display: block;
  }
}
.contact-form-box {
  display: inline-block;
}
.contact-form-email-list {
  margin-bottom: 1em;
}
.contact-form-email-list-item {
  display: flex;
  justify-content: space-between;
}
.contact-form-email-list__email {
  margin-right: 1em;
}
</style>
